import SiteLink from 'components/shared/sitelink/sitelink';
import Image from 'components/shared/image';
import useSearchContentTracking from 'hooks/tracking/useSearchContentTracking';
import { useRouter } from 'next/router';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useMemo } from 'react';
import { formatPriceByStoreLocale } from 'lib/shopify';
import UnitPrice from 'components/shared/unit-price';
import styles from './searchHit.module.scss';

// showPrice is undefined
// JW's request in productive 10232808
const SearchHit = ({ className, locale, searchHitData, searchQuery, showPrice, resources }) => {
  const { productTags, image, slug, title, shopifyData, productsCollection, size } = searchHitData;

  const stock = useMemo(() => {
    if (!productsCollection)
      return {
        outOfStock: shopifyData?.variants?.[0]?.outOfStock,
        price: shopifyData?.variants?.[0]?.price || 0,
        unitPrice: shopifyData?.variants?.[0]?.unitPrice || {},
      };

    const totalPrice = productsCollection.items
      .reduce(
        (prev, current) => prev + parseFloat(current.shopifyData?.variants?.[0]?.price || 0),
        0
      )
      .toFixed(2);

    return {
      outOfStock: productsCollection.items.every(
        item => item.shopifyData?.variants?.[0]?.outOfStock
      ),
      price: totalPrice,
    };
  }, [productsCollection, shopifyData]);

  // const { outOfStock } = shopifyData?.variants[0] || {};
  const { outOfStock: outOfStockText, localesWithWebshop } = resources;
  const router = useRouter();

  const trackSearchResultClick = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSearchContentTracking({
      searchQuery,
      searchResult: {
        type: 'product',
        slug,
      },
      location: { action: router },
    });
  };

  return (
    <SiteLink
      locale={locale}
      onClick={trackSearchResultClick}
      className={className}
      href={addLocaleToHref(`p/${slug}`, locale, router)}
    >
      <div className={styles.imageBackdrop}>
        <div className={styles.imageWrapper}>
          <Image src={image} layout="fill" loading="eager" priority />
        </div>
      </div>
      <div className={styles.productTagsRow}>
        {stock.outOfStock && localesWithWebshop?.onOrOff && (
          <div className={styles.outOfStockTag}>{outOfStockText?.text}</div>
        )}
        {!stock.outOfStock &&
          productTags?.map(productTag => (
            <div key={productTag} className={styles.productTag}>
              {productTag}
            </div>
          ))}
      </div>
      <div className={styles.productInfo}>
        <h2 className={styles.productName}>{title}</h2>
        {showPrice && Boolean(stock.price) && (
          <>
            <span className={styles.productPrice}>
              {formatPriceByStoreLocale({
                locale,
                price: stock.price,
              })}
            </span>
            <UnitPrice
              size={size}
              unitPrice={stock.unitPrice}
              locale={locale}
              price={stock.price}
              globalModules={resources}
            />
          </>
        )}
      </div>
    </SiteLink>
  );
};

export default SearchHit;
